import React from 'react'
import System from 'src/helper/system';
import Helper from 'src/helper/Helper';
import { useOrderStore } from 'src/hooks/order';
import { useState, useEffect } from 'react';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { Tooltip } from 'src/component/Global/Tooltip';
import Constants from 'src/helper/Constants';
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import noncancel from "src/assets/images/icon-non-cancel-black.png";
import useReduxState from 'src/hooks/useReduxState';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { useSystem } from "src/hooks/system";

const OrderDetailByShipment = () => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ order_detail, selected_fields }, { }, { order_download_invoice, toggle_single_selected_fields, remove_single_selected_fields }] = useOrderStore();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

    const [ascDesField, setAscDesField] = useState({});
    const [expandedRow, setExpandedRowT] = useState([])
    const [orderByShipment, setOrderByShipment] = useState([])
    const [isReorderable] = useReduxState(false, 'setIsReOrderable')
    const [isCancellable] = useReduxState(false, 'setIsCancellable')
    const [sortedData, setSortedData] = useState();

    const {currencyType: { USD }, siteUser: { CORE }, downloadMsg } = Constants
    const isCoreUser =  System.avUserInfoData.currentUser === CORE
    const [,{ get_quantity_format }] = useSystem();

    useEffect(() => {
        if(order_detail?.orderItemByShipment) {
            setOrderByShipment(order_detail?.orderItemByShipment)
        }
    }, [order_detail]);

    useEffect(() => {
        const filteredData = orderByShipment.reduce((acc, item) => {
            acc[item.shipment] = item.orderItems;
            return acc;
        }, {});

        setSortedData(filteredData)
        setExpandedRowT(orderByShipment.map(item => item.shipment).flat())
    }, [order_detail, orderByShipment])

    const sortAttributes = (columnName, shipmentName) => {
        let shipmentData = orderByShipment.find(x => x.shipment === shipmentName)?.orderItems;
    
        if (!shipmentData) return;

        let Attributes = [...shipmentData];
        let AttributesSorted = [];

        const currentSortState = ascDesField[shipmentName] || {};
        const currentColumn = currentSortState.column;
        const currentDirection = currentSortState.direction || 'ASC';

        const newDirection = (currentColumn === columnName && currentDirection === 'ASC') ? 'DESC' : 'ASC';

        setAscDesField((prevState) => ({
            ...prevState,
            [shipmentName]: {
                column: columnName,
                direction: newDirection,
            },
        }));

        if (newDirection === 'ASC') {
            if (columnName === 'orderQuantity' || columnName === 'shippedQuantity' || columnName === 'remainingQty' || columnName === 'unitPrice' || columnName === 'totalLinePrice') {
                AttributesSorted = Attributes.sort((a, b) => (parseInt(a[columnName]) < parseInt(b[columnName]) ? -1 : 1));
            } else {
                AttributesSorted = Attributes.sort((a, b) => (a[columnName] < b[columnName] ? -1 : 1));
            }
        } else if (newDirection === 'DESC') {
            if (columnName === 'orderQuantity' || columnName === 'shippedQuantity' || columnName === 'remainingQty' || columnName === 'unitPrice' || columnName === 'totalLinePrice') {
                AttributesSorted = Attributes.sort((a, b) => (parseInt(a[columnName]) > parseInt(b[columnName]) ? -1 : 1));
            } else {
                AttributesSorted = Attributes.sort((a, b) => (a[columnName] > b[columnName] ? -1 : 1));
            }
        }
    
        setSortedData((prevState) => ({
            ...prevState,
            [shipmentName]: AttributesSorted,
        }));
    };

    const getOrderByClass = (columnName, shipmentName) => {
        const sortingState = ascDesField[shipmentName] || {};
        if (sortingState.column === columnName) {
            return `sorting sorting_${sortingState.direction?.toLowerCase()}`;
        }
        return 'sorting';
    };

    const handleClick = async (shipment) => {
        const orderItems = orderByShipment.filter(row => row.shipment === shipment)[0]?.orderItems

        setExpandedRowT(prevExpandedRow => {
            if (prevExpandedRow.includes(shipment)) {
                if (orderItems && Array.isArray(orderItems)) {
                    orderItems.map(item => remove_single_selected_fields(item));
                }
                delete sortedData[shipment]
                return prevExpandedRow.filter(row => row !== shipment);
            } else {
                sortedData[shipment] = orderItems
                return [...prevExpandedRow, shipment];
            }
        });
    }

    const renderLegendIcon = (iconPath, message, showIcon) => {
        return (
            showIcon ?
                (
                    <span className="list-text-icon"><img className="img-fluid me-1" alt="Legend Information Icon" src={iconPath} /></span>
                ) :
                (
                    <Tooltip
                        position={'bottom left'}
                        opener={() => (
                            <span className="list-text-icon"><img
                                className="img-fluid me-1" alt="Legend Information Icon"
                                src={iconPath} /></span>
                        )}
                        content={() => (
                            message
                        )}
                    />
                )
        )
    };

    const onToggleSelect = (values) => {
        let selectedField = { ...values }
        toggle_single_selected_fields({ ...selectedField })
    }

    const getStatusOfForFieldActivated = (selectedList) => {
        if (selected_fields && selected_fields[selectedList.uniqueNumber] !== undefined) {
            return selected_fields[selectedList.uniqueNumber];
        }

        return false
    };

    const downloadInvoice = async (invoiceNumber) => {
        const result = await order_download_invoice(invoiceNumber);
        if (result) {
            system_alert_indicator({
                name: 'DownloadOrder',
                message: downloadMsg,
                type: "success"
            })
        }
    }

    return (
        <>
            {__check(['GET_ORDER_DETAIL']).render}

            <div id="tab1" className="tab-pane fade position-relative in active">
                {!__check(['GET_ORDER_DETAIL']).status &&
                    orderByShipment?.map((v, i) => (
                        <div className="accordion" id="orders" key={i}>
                            <div className="accordion-item rounded-0">
                                {v.orderItems?.length > 0 && 
                                    <h2 className="accordion-header mb-0" id="headingOne">
                                        <button className="accordion-button accordion-white-button cursor-default">
                                            <div className="shipment-head">
                                                <div className="accordian-arrow">
                                                    <i
                                                        className={expandedRow?.includes(v.shipment) ? 'fa fa-angle-double-up me-0 d-block' : 'fa fa-angle-double-down me-0 d-block'}

                                                        onClick={() => handleClick(v.shipment)}
                                                    />
                                                </div>
                                                <div className="sub-section w240">
                                                    <div><strong className="font-16 text-uppercase">{v.shipment}</strong></div>
                                                </div>
                                                <div className="sub-section w200">
                                                    <div><strong className="font-13 font-arial">Shipped on Date</strong></div>
                                                    <div className='sub-section-data text-wrap font-13 font-arial'>{v.shippedDate && v.shippedDate.trim() !== '' ? Helper.convertOrderModuleDateFormat(v.shippedDate) : '-'}</div>
                                                </div>
                                                <div className="sub-section w200">
                                                    <div><strong className="font-13 font-arial">Line Status</strong></div>
                                                    <div className='sub-section-data text-wrap font-13 font-arial'>{v.orderStatus && v.orderStatus.trim() !== '' ? v.orderStatus : '-'}</div>
                                                </div>
                                                {v.shipment !== 'Not Yet Shipped' && 
                                                    <><div className="sub-section w200">
                                                        <div><strong className="font-13 font-arial">Release Number</strong></div>
                                                        <div className='sub-section-data text-wrap font-13 font-arial'>{v.releaseNo && v.releaseNo.trim() !== '' ? v.releaseNo : '-'}</div>
                                                    </div>
                                                    <div className="sub-section w240">
                                                        <div><strong className="font-13 font-arial">Tracking/Waybill Number</strong></div>
                                                            <div className='sub-section-data text-wrap font-13 font-arial'>{v?.trackingDetails ? v?.trackingDetails?.length > 2 ? 
                                                                <a onClick={() => System.popup('OrderDetailViewAllTrackingPopup',{trackingDetails: v.trackingDetails, poNumber: order_detail.poNumber})}>View all Tracking</a> : 
                                                                v.trackingDetails.map((value, index) => (
                                                                    <div key={index}>
                                                                        {value.trackingUrl ?
                                                                            <a href={value.trackingUrl} target='_blank'><span className='text-blue'>{value?.trackingNo}</span></a> :
                                                                            <span className='text-black'>{value?.trackingNo}</span>}
                                                                        </div>
                                                                )) : '-'}
                                                            </div>
                                                    </div>
                                                    <div className="sub-section">
                                                        <div><strong className="font-13 font-arial">Invoice Number</strong></div>
                                                        <div className="sub-section-data text-wrap font-13 font-arial">
                                                            <a href={void (0)} aria-label="InvoiceGenerationlink"
                                                                onClick={() => downloadInvoice([v.invoiceNo])}>{v.invoiceNo && v.invoiceNo.trim() !== '' ? v.invoiceNo : '-'} </a>
                                                            <input type="hidden" id="invoiceUrlGeneration1" />
                                                        </div>
                                                    </div></>
                                                }
                                            </div>
                                        </button>
                                    </h2>
                                }

                                {v.orderItems && v.orderItems.length > 0 &&
                                    <div className={expandedRow?.includes(v.shipment) ? "table-responsive mb-0" : "table-responsive mb-0 d-none"} aria-labelledby="headingOne">
                                        <div className="accordion-body p-0">
                                            <div className="table-responsive orderdetailbyshipment">
                                                <table className="bs5 table table-bordered mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th className="w40"></th>
                                                            {isCoreUser && <th className=""></th>}
                                                            <th className="w100"><span>Line Item <br />Number</span></th>
                                                            <th className={
                                                                getOrderByClass('manufacturerName', v.shipment)
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('manufacturerName', v.shipment)
                                                                }}><span>Manufacturer</span></th>
                                                            <th className={
                                                                getOrderByClass('manufacturerPartNumber', v.shipment) + ' maxw170'
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('manufacturerPartNumber', v.shipment)
                                                                }}><span>Manufacturer Part<br />Number</span></th>
                                                           {isCoreUser && <th className={
                                                                getOrderByClass('customerPartNumber', v.shipment)  + ' minw140'
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('customerPartNumber', v.shipment)
                                                                }}><span>Customer Part Number</span></th>}
                                                            <th className={
                                                                getOrderByClass('orderQuantity', v.shipment)
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('orderQuantity', v.shipment)
                                                                }}><span>Ordered Quantity</span></th>
                                                            {v.shipment !== 'Not Yet Shipped' && <th className={
                                                                getOrderByClass('shippedQuantity', v.shipment)
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('shippedQuantity', v.shipment)
                                                                }}><span>Shipped Quantity</span></th>}
                                                            <th className={
                                                                getOrderByClass('remainingQty', v.shipment)
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('remainingQty', v.shipment)
                                                                }}><span>Total Remaining Quantity</span></th>
                                                            <th className={
                                                                getOrderByClass('unitPrice', v.shipment)
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('unitPrice', v.shipment)
                                                                }}><span>Unit Price</span></th>
                                                            <th className={
                                                                getOrderByClass('totalLinePrice', v.shipment)
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('totalLinePrice', v.shipment)
                                                                }}><span>Shipment Price</span></th>
                                                            <th className={
                                                                getOrderByClass('nCNR', v.shipment)
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('nCNR', v.shipment)
                                                                }}><span>Information</span></th>
                                                            {isCoreUser && <th className={
                                                                getOrderByClass('scheduleDate', v.shipment)
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('scheduleDate', v.shipment)
                                                                }}><span>Customer Requested Date</span></th>}
                                                            <th className={
                                                                getOrderByClass('deliveryDate', v.shipment)
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('deliveryDate', v.shipment)
                                                                }}><span>Expected Delivery Date</span></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Object.entries(sortedData)?.map((k, i) => {
                                                            if (v.shipment === k[0]) {
                                                                return k[1]?.map((j, i) => (
                                                                    <tr className={`align-middle ${((isReorderable && !j.isReOrder) || (isCancellable && !j.isCancel)) && 'disabled'}`} key={i}>
                                                                        <td>
                                                                            <div>{(isReorderable || isCancellable) && 
                                                                                <div className="form-check d-flex align-items-center font-15 ps-0">
                                                                                    <input type="checkbox" className="form-check-input ms-0"
                                                                                        id="forCheckbox"
                                                                                        onChange={() => (onToggleSelect(j))}
                                                                                        checked={getStatusOfForFieldActivated(j)}
                                                                                        disabled={(isReorderable && !j.isReOrder) || (isCancellable && !j.isCancel)}
                                                                                    />
                                                                                    <label className="form-check-label" htmlFor="forCheckbox" />
                                                                                </div>
                                                                            }
                                                                            </div>
                                                                        </td>
                                                                        {isCoreUser && <td>
                                                                            <div>
                                                                                <a className="text-blue2 d-flex align-items-center" href={void (0)}
                                                                                    onClick={() => System.popup('OrderHistoryEmailPopUp', {
                                                                                        singleOrder: order_detail,
                                                                                        singleProduct: {...j,quantity:j.orderQuantity}
                                                                                    })}>
                                                                                    <i className="fa fa-envelope font-16" aria-hidden="true"></i>
                                                                                </a>
                                                                            </div>
                                                                        </td>}
                                                                        <td><div>{j.itemNo ? j.itemNo : ''}</div></td>
                                                                        <td><div>{j.manufacturerName ? j.manufacturerName : ''}</div></td>
                                                                        <td>
                                                                            {j?.orderItemNumber && j.manufacturerPartNumber ?
                                                                                <NavigateToProductDetail
                                                                                    target="_blank"
                                                                                    data={{ ManufacturerName: j?.manufacturerName, ERPMFRPartNumber: j?.manufacturerPartNumber, ItemNumber: j?.orderItemNumber, ERPPartNumber: j?.sapMaterialNo }}>
                                                                                    <span className="text-nowrap text-blue2">{j.manufacturerPartNumber ? j.manufacturerPartNumber : ''}</span>
                                                                                </NavigateToProductDetail> :  
                                                                                <span className="text-nowrap">{j.manufacturerPartNumber ? j.manufacturerPartNumber : ''}</span>
                                                                            }
                                                                            
                                                                            <p className='mb-0'>{j.manufacturerPartDesc ? j.manufacturerPartDesc : ''}</p>
                                                                        </td>
                                                                        {isCoreUser && <td><span className="text-nowrap">{j.customerPartNumber ? j.customerPartNumber : ''}</span></td>}
                                                                        <td><span className="text-nowrap">{get_quantity_format(Number(j.orderQuantity))}</span></td>
                                                                        {v.shipment !== 'Not Yet Shipped' && <td><span className="text-nowrap">{get_quantity_format(Number(j.shippedQuantity))}</span></td>}
                                                                        <td><span className="text-nowrap">{get_quantity_format(Number(j.remainingQty))}</span></td>
                                                                        <td><span className="text-nowrap">{j.unitPrice ? System.getFormatNumber({ amount: Number(j.unitPrice), currency: USD}) : ""}</span></td>
                                                                        <td><span className="text-nowrap">{j.totalLinePrice ? System.getFormatNumber({ amount: Number(j.totalLinePrice), currency: USD,maximumFractionDigits: 2}) : ''}</span></td>
                                                                        <td><span className="text-nowrap">{j.nCNR ? renderLegendIcon(noncancel, 'Non-Cancelable, Non-Returnable', false) : ""}</span></td>
                                                                        {isCoreUser && <td><span className="text-nowrap">{j.scheduleDate ? Helper.convertOrderModuleDateFormat(j.scheduleDate) : ''}</span></td>}
                                                                        <td><span className="text-nowrap">{j.deliveryDate ? Helper.convertOrderModuleDateFormat(j.deliveryDate): ''}</span></td>
                                                                    </tr>
                                                                ))
                                                        }})}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
        </>
    )
}

export default OrderDetailByShipment